const { post, adminCall } = require("./_utils");

module.exports = {
  remove: (uid) => adminCall("user.remove", { uid }),
  signup: (data) => post("/signup", { data }),
  changeAvatar: ({ uid, avatar, password }) => {
    return adminCall("user.changeAvatar", {
      uid,
      password,
      avatar
    })
  },
  generateAvatar: async () => {
    let avatar = await adminCall("user.generateAvatar")
    //console.log(avatar);
    return avatar
  }
}
